const RECENTS_KEY = 'ludus_recent_scenarios';
const MAX_RECENTS = 5;

export function recordScenarioOpened(scenario) {
  if (!scenario?.id) return;

  const entry = {
    id: scenario.id,
    titleAr: scenario.title_ar || scenario.title_en || '',
    titleEn: scenario.title_en || scenario.title_ar || '',
    openedAt: new Date().toISOString(),
  };

  const previous = getRecentScenarioActivity().filter((item) => item.id !== entry.id);
  localStorage.setItem(RECENTS_KEY, JSON.stringify([entry, ...previous].slice(0, MAX_RECENTS)));
}

export function getRecentScenarioActivity() {
  try {
    const saved = JSON.parse(localStorage.getItem(RECENTS_KEY) || '[]');
    return Array.isArray(saved) ? saved : [];
  } catch (_) {
    localStorage.removeItem(RECENTS_KEY);
    return [];
  }
}
